import React, { useEffect, useMemo, useState } from "react";
import objectPath from "object-path";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { QuickUserToggler } from "../extras/QuiclUserToggler";
import { EnvironmentActions } from "../../../../app/modules/GetEnvironment";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import Select from "react-select";
import { useIsAccessAllow } from "../../../../app/modules/users/redux";
// import { useIsAccessAllow } from "../../../../../../../users/redux";

export function Topbar() {
  const dispatch = useDispatch();
  const uiService = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      viewSearchDisplay: objectPath.get(
        uiService.config,
        "extras.search.display"
      ),
      viewNotificationsDisplay: objectPath.get(
        uiService.config,
        "extras.notifications.display"
      ),
      viewQuickActionsDisplay: objectPath.get(
        uiService.config,
        "extras.quick-actions.display"
      ),
      viewCartDisplay: objectPath.get(uiService.config, "extras.cart.display"),
      viewQuickPanelDisplay: objectPath.get(
        uiService.config,
        "extras.quick-panel.display"
      ),
      viewLanguagesDisplay: objectPath.get(
        uiService.config,
        "extras.languages.display"
      ),
      viewUserDisplay: objectPath.get(uiService.config, "extras.user.display"),
    };
  }, [uiService]);

  /* HireAI GetQuote Allow Start */
  const [filterWebsiteLists, setFilterWebsiteLists] = useState([]);

  const { websiteLists, web_id } = useSelector(
    (state) => state.environnment,
    shallowEqual
  );

  const { user } = useSelector((state) => state.auth);
  const webcluesinfotech = useIsAccessAllow("get_a_quote.webcluesinfotech");
  const wdcstechnology = useIsAccessAllow("get_a_quote.wdcs_technology");
  const wdcsdubai = useIsAccessAllow("get_a_quote.wdcs_dubai");

  const isHireAIGetQuoteAllow = useIsAccessAllow(
    "get_a_quote.hire_ai_get_quote"
  );
  const isHfdiGetQuoteAllow = useIsAccessAllow("get_a_quote.hfdi_get_quote");
  const isBdcGetQuoteAllow = useIsAccessAllow("get_a_quote.bdc_get_quote");
  const isHfdGetQuoteAllow = useIsAccessAllow("get_a_quote.hfd_get_quote");
  const isIcodGetQuoteAllow = useIsAccessAllow("get_a_quote.icod_get_quote");
  const isHbdGetQuoteAllow = useIsAccessAllow("get_a_quote.hbd_get_quote");
  const isFdcGetQuoteAllow = useIsAccessAllow("get_a_quote.fcd_get_quote");

  // Map each item.value to the corresponding permission flag
  const permissionValueMap = {
    webcluesinfotech: webcluesinfotech,
    wdcstechnology: wdcstechnology,
    wdcsdubai: wdcsdubai,
    hireaideveloper: isHireAIGetQuoteAllow,
    hirefullstackdeveloperindia: isHfdiGetQuoteAllow,
    backenddevelopmentcompany: isBdcGetQuoteAllow,
    hirefrontenddeveloperindia: isHfdGetQuoteAllow,
    icodevelopment: isIcodGetQuoteAllow,
    hirebackenddeveloper: isHbdGetQuoteAllow,
    frontenddevelopmentcompany: isFdcGetQuoteAllow,
    // Add more entries as needed
  };

  // Filtering logic
  useEffect(() => {
    const filtered = websiteLists.filter((item) => {
      const isAllowed = permissionValueMap[item.value];
      return user.roleId !== 1 && isAllowed;
    });

    setFilterWebsiteLists(filtered.length > 0 ? filtered : websiteLists);
  }, [
    websiteLists,
    user.roleId,
    isHireAIGetQuoteAllow,
    isHfdiGetQuoteAllow,
    isBdcGetQuoteAllow,
    isHfdGetQuoteAllow,
    isIcodGetQuoteAllow,
    isHbdGetQuoteAllow,
    isFdcGetQuoteAllow,
    webcluesinfotech,
    wdcstechnology,
    wdcsdubai,
    // Add more dependencies if you add more permissions
  ]);


  return (
    <div className="topbar">
      {layoutProps.viewUserDisplay && <QuickUserToggler />}
    </div>
  );
}
